import * as signalR from '@microsoft/signalr';
import { tokenManager } from '../utils/tokenManager';
import { ENV } from '../config/environment';

export class SignalRService {
  private connection: signalR.HubConnection | null = null;
  private isConnecting = false;

  constructor() {}

  async connect(): Promise<signalR.HubConnection> {
    if (this.connection && this.connection.state === signalR.HubConnectionState.Connected) {
      return this.connection;
    }

    if (this.isConnecting) {
      return new Promise((resolve, reject) => {
        const checkConnection = () => {
          if (this.connection && this.connection.state === signalR.HubConnectionState.Connected) {
            resolve(this.connection);
          } else if (!this.isConnecting) {
            reject(new Error('Connection failed'));
          } else {
            setTimeout(checkConnection, 100);
          }
        };
        checkConnection();
      });
    }

    this.isConnecting = true;

    try {
      const token = tokenManager.getAccessToken();
      if (!token) {
        throw new Error('No access token available');
      }

      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(`${ENV.NOTIFICATION_SERVICE_URL}/notificationHub`, {
          accessTokenFactory: () => token,
        })
        .withAutomaticReconnect([0, 2000, 10000, 30000])
        .configureLogging(signalR.LogLevel.Error)
        .build();

      this.connection.onreconnecting(() => {
      });

      this.connection.onreconnected(() => {
        this.joinUserGroup();
      });

      this.connection.onclose(() => {
        this.isConnecting = false;
      });

      await this.connection.start();

      await this.joinUserGroup();
      
      this.isConnecting = false;
      return this.connection;
    } catch (error) {
      this.isConnecting = false;
      throw error;
    }
  }

  async disconnect(): Promise<void> {
    if (this.connection) {
      await this.connection.stop();
      this.connection = null;
    }
  }

  private async joinUserGroup(): Promise<void> {
  }

  onNotificationReceived(callback: (notification: any) => void): void {
    if (this.connection) {
      this.connection.on('ReceiveNotification', callback);
    }
  }

  offNotificationReceived(): void {
    if (this.connection) {
      this.connection.off('ReceiveNotification');
    }
  }

  getConnectionState(): signalR.HubConnectionState | null {
    return this.connection?.state || null;
  }

  isConnected(): boolean {
    return this.connection?.state === signalR.HubConnectionState.Connected;
  }
}

export const signalRService = new SignalRService();